import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { generalSelectors } from 'models/General'
import redemptionsSelectors from 'models/Redemptions/selectors'

import ReklaimModal, { ModalHeader, ModalBody } from 'components/ReklaimModal'

import { STRING } from 'resources'
import { INTERCOM_KB_URLS } from 'resources/urls'

import { RedemptionRequirementsModalTitle, RedemptionRequirementText, GotItButton } from './styles'
import RedemptionRequirementItem from './RedemptionRequirementItem'

const RedemptionRequirements = ({ isOpen, onClose, promptUserRefresh }) => {
  const {
    hasMinAccountMaturity,
    hasNoOpenRedemptions,
    hasNoRecentRedemptions,
    hasNoMultipleAccounts,
    hasPrimaryEmail,
    hasPrimaryPhone,
  } = useSelector(redemptionsSelectors.getRedemptionRequirements)
  const redemptionMinAge = useSelector(generalSelectors.getRedemptionMinAccountAge)
  const redemptionMinRequestInterval = useSelector(generalSelectors.getRedemptionMinRequestInterval)
  const remainingDaysAccountMaturity = useSelector(redemptionsSelectors.getRemainingDaysAccountMaturity)
  const remainingDaysNextRedemption = useSelector(redemptionsSelectors.getRemainingDaysNextRedemption)

  // Account Maturity
  let accountMaturityMessage = STRING.wallet.redemptions.redemptionRequirements.accountMaturity(redemptionMinAge)
  accountMaturityMessage += !hasMinAccountMaturity
    ? STRING.wallet.redemptions.redemptionRequirements.accountMaturityRemainingDays(remainingDaysAccountMaturity)
    : ''

  // No Open Redemption
  const noOpenRedemptionMessage = STRING.wallet.redemptions.redemptionRequirements.onlyOneOpenRedemption

  // No Recent Redemption
  let noRecentRedemptionMessage =
    STRING.wallet.redemptions.redemptionRequirements.noRecentRedemption(redemptionMinRequestInterval)
  noRecentRedemptionMessage += !hasNoRecentRedemptions
    ? STRING.wallet.redemptions.redemptionRequirements.noRecentRedemptionRemainingDays(remainingDaysNextRedemption)
    : ''

  let primaryEmailMessage = STRING.wallet.redemptions.redemptionRequirements.requirementEmailVerification
  primaryEmailMessage += !hasPrimaryEmail ? STRING.wallet.redemptions.redemptionRequirements.missingIdentifierFix : ''

  let primaryPhoneMessage = STRING.wallet.redemptions.redemptionRequirements.requirementPhoneVerification
  primaryPhoneMessage += !hasPrimaryPhone ? STRING.wallet.redemptions.redemptionRequirements.missingIdentifierFix : ''

  return (
    <ReklaimModal isOpen={isOpen} centered>
      <ModalHeader toggle={onClose} />
      <ModalBody>
        <RedemptionRequirementsModalTitle>
          {STRING.wallet.redemptions.redemptionRequirements.requirementHeader}
        </RedemptionRequirementsModalTitle>
        {promptUserRefresh ? (
          <RedemptionRequirementText>
            {STRING.wallet.redemptions.redemptionRequirements.promptUserRefresh}
          </RedemptionRequirementText>
        ) : (
          <>
            <RedemptionRequirementItem
              requirementText={accountMaturityMessage}
              isRequirementMet={hasMinAccountMaturity}
            />
            <RedemptionRequirementItem
              requirementText={noOpenRedemptionMessage}
              isRequirementMet={hasNoOpenRedemptions}
            />
            <RedemptionRequirementItem
              requirementText={noRecentRedemptionMessage}
              isRequirementMet={hasNoRecentRedemptions}
            />
            <RedemptionRequirementItem
              requirementText={STRING.wallet.redemptions.redemptionRequirements.requirementMultipleAccounts.label}
              fixButtonText={STRING.wallet.redemptions.redemptionRequirements.requirementMultipleAccounts.fixButton}
              fixLink={INTERCOM_KB_URLS.MULTIPLE_DEVICES}
              isRequirementMet={hasNoMultipleAccounts}
            />
            {hasPrimaryEmail != null && (
              <RedemptionRequirementItem requirementText={primaryEmailMessage} isRequirementMet={hasPrimaryEmail} />
            )}
            {hasPrimaryPhone != null && (
              <RedemptionRequirementItem requirementText={primaryPhoneMessage} isRequirementMet={hasPrimaryPhone} />
            )}
          </>
        )}
        <GotItButton onPress={onClose}>{STRING.wallet.redemptions.redemptionRequirements.gotItButton}</GotItButton>
      </ModalBody>
    </ReklaimModal>
  )
}

RedemptionRequirements.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  promptUserRefresh: PropTypes.bool.isRequired,
}

export default RedemptionRequirements
